<template>
  <div class="menu-library-panel">
    <div class="panel-header">菜单功能模板库</div>
    
    <!-- 菜单模板区域 -->
    <el-collapse v-model="activeModules" accordion>
      <el-collapse-item 
        v-for="module in menuLibrary" 
        :key="module.IDSEQ"
        :name="module.IDSEQ"
      >
        <template slot="title">
          <div 
            class="category-title"
            draggable="true"
            @dragstart.stop="handleDragModule($event, module)"
          >
            <i class="el-icon-menu"></i>
            <span>{{ module.MODNM }}</span>
          </div>
        </template>
        
        <div class="menu-items">
          <div
            v-for="form in module.forms"
            :key="form.IDSEQ"
            class="menu-item"
            draggable="true"
            @dragstart="handleDragStart($event, form, module)"
          >
            <i class="el-icon-s-grid"></i>
            <span class="menu-name">{{ form.FRMNM }}</span>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getTabColOrData } from '@/api/user'

export default {
  name: 'MenuLibraryPanel',
  props: {
    lf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      menuLibrary: [],
      activeModules: [],
      v_username: this.$cookies.get('v_telno'),
 
      v_corpid: this.$cookies.get('v_corpid'),
      v_url:  'xuper_auth/getTableRecMany'
    }
  },
  mounted() {
    this.loadMenuData()
  },
  methods: {
    async loadMenuData() {
      try {
        // 直接加载所有模块-表单数据
        const res = await getTabColOrData(
          this.v_url,
 
          'V_SYS_MOD_FORM',
          '',
          '',
          '',
          '',
          '',
          '',
          ' order by MODIDSEQ, SORTBY'
        )
        
        const allData = res.result || []
        
        // 按模块分组
        const moduleMap = {}
        allData.forEach(item => {
          const modId = item.MODIDSEQ
          if (!moduleMap[modId]) {
            moduleMap[modId] = {
              IDSEQ: modId,           // 模块主键（MODIDSEQ）
              MODIDSEQ: modId,        // 保留原始字段
              MODNM: item.MODNM,      // 模块名称
              forms: []
            }
          }
          moduleMap[modId].forms.push({
            IDSEQ: item.IDSEQ,           // V_SYS_MOD_FORM 的主键（菜单编码）
            FRMIDSEQ: item.FRMIDSEQ,     // 表单主键
            FRMNM: item.TITLE,           // 表单名称
            FRMURL: item.FRMURL || '',   // 菜单URL
            SORTBY: item.SORTBY
          })
        })
        
        // 转换为数组
        this.menuLibrary = Object.values(moduleMap)
      } catch (error) {
        this.$message.error('加载菜单数据失败')
      }
    },
    
    handleDragModule(event, module) {
      const dragData = {
        type: 'moduleWithForms',
        module: module
      }
      event.dataTransfer.setData('application/json', JSON.stringify(dragData))
      event.dataTransfer.effectAllowed = 'copy'
    },
    
    handleDragStart(event, form, module) {
      const dragData = {
        type: 'single',
        form: form,
        module: module
      }
      event.dataTransfer.setData('application/json', JSON.stringify(dragData))
      event.dataTransfer.effectAllowed = 'copy'
    }
  }
}
</script>

<style scoped>
.menu-library-panel {
  position: absolute;
  left: 0;
  top: 0;
  width: 280px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e4e7ed;
  overflow-y: auto;
  z-index: 10;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.panel-header {
  padding: 20px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  background: #fafafa;
  letter-spacing: 0.5px;
}

.category-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  cursor: move;
  padding: 0 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.category-title:hover {
  background: #ecf5ff;
}

.category-title i {
  margin-right: 8px;
  color: #409eff;
  font-size: 16px;
}

.menu-items {
  padding: 4px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: move;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  margin: 2px 0;
}

.menu-item:hover {
  background: #f5f7fa;
  border-left-color: #409eff;
}

.menu-item i {
  margin-right: 10px;
  color: #909399;
  font-size: 14px;
  flex-shrink: 0;
}

.menu-item .menu-name {
  flex: 1;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}

.menu-item.drag-all {
  background: #ecf5ff;
  border-left-color: #409eff;
  margin-top: 8px;
  font-weight: 500;
  border-radius: 4px;
  margin-left: 8px;
  margin-right: 8px;
  padding-left: 24px;
}

.menu-item.drag-all:hover {
  background: #d9ecff;
}

.menu-item.drag-all .menu-name {
  color: #409eff;
}

.menu-item.drag-all i {
  color: #409eff;
}

/* 折叠面板样式调整 */
::v-deep .el-collapse {
  border: none;
}

::v-deep .el-collapse-item__header {
  height: 48px;
  line-height: 48px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 16px;
  font-size: 14px;
  transition: background-color 0.2s;
}

::v-deep .el-collapse-item__header:hover {
  background: #fafafa;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none;
  background: #fafafa;
}

::v-deep .el-collapse-item__content {
  padding: 8px 0;
}

/* 滚动条美化 */
.menu-library-panel::-webkit-scrollbar {
  width: 6px;
}

.menu-library-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.menu-library-panel::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.menu-library-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
